import { team } from '../../data';

export default {
    name: 'aboutUsTeamSection',
    title: 'About Us Team Section',
    type: 'document',
    initialValue: {
        title: 'Our Team',
        description: 'At Bansah and Associates Immigration Counsel, our dedicated team of professionals and staff is committed to guiding clients through the complexities of immigration law. We provide tailored solutions and unwavering support at every stage of the process. Our dedication to excellence, integrity, and client satisfaction distinguishes us as a trusted and reputable source for immigration assistance. Contact us today or book an appointment to get the expert guidance you need.',
        teamMembers: team
    },
    fields: [
        { name: 'title', title: 'Title', type: 'string', validation: Rule => Rule.required() },
        { name: 'description', title: 'Description', type: 'text', validation: Rule => Rule.required() },
        {
            name: 'teamMembers',
            title: 'Team Members',
            type: 'array',
            of: [
                {
                    type: 'object',
                    fields: [
                        { name: 'name', title: 'Name', type: 'string', validation: Rule => Rule.required() },
                        { name: 'position', title: 'Position', type: 'string', validation: Rule => Rule.required() },
                        { name: 'image', title: 'Image', type: 'image', options: { hotspot: true }, validation: Rule => Rule.required() }
                    ]
                }
            ],
            validation: Rule => Rule.required().min(1)
        }
    ],
    preview: {
        select: {
            title: 'title',
            description: 'description'
        },
        prepare(selection) {
            const { title, description } = selection;
            return {
                title,
                subtitle: description,
            };
        }
    }
} 